import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { AuthGuard } from 'shared/auth/auth.guard';
import { PermissionsResolver } from 'shared/permissions/permissions.resolver';
import { PreferencesResolver } from 'shared/preferences/preferences.resolver';
import { SubscriptionGuard } from 'shared/subscription/subscription.guard';

import { DashboardComponent } from './dashboard.component';


@NgModule({
  imports: [
    RouterModule.forRoot([
    {
        path: 'dashboard',
        component: DashboardComponent,
        canActivate: [AuthGuard, SubscriptionGuard],
        resolve: {
            permissions: PermissionsResolver,
            preferences: PreferencesResolver,
        },
    },
    {
        path: '',
        redirectTo: 'dashboard',
        pathMatch: 'full',
    },
])
  ],
  exports: [RouterModule]
})
export class DashboardRoutingModule { }
